/*
 * HEADER
 *
 */
import React from 'react';
import { CTASettings } from '@/utils/types/CTASettings';
import CTA from '@/components/shared/CTA';
import HeaderPromo from '@/components/layout/HeaderPromo';
import Logo from '@/components/shared/Logo';
import Menu from '@/components/shared/Menu';
import SearchForm from '@/components/layout/SearchForm';
import '@/styles/components/sites-menu.scss';
import '@/styles/components/header.scss';

const Header: React.FC = () => {
    // CTA settings
    const ctaSettings: CTASettings = {
        url: '?campaign=855790',
        text: 'Donate',
        modal: false,
        classes: [ 'solid-button', 'color-red', 'header-cta' ],
    };

    return (
        <>
            <a href="#content" tabIndex={ 1 } className="screen-reader-text">Skip to main content</a>
            { /* Google Tag Manager (noscript) */ }
            
            <aside id="af-header-promo">
                <div className="container">
                    <HeaderPromo />
                    <Menu name="social-nav" />
                </div>
            </aside>
            <header id="af-header">
                <nav id="af-navbar-main" className="container">
                    <Logo id="af-navbar-logo" />
                    <div id="af-navbar-menu">
                        <Menu name="main-nav" />
                        <div id="af-navbar-utilities" /* className="search-toggle" */>
                            <div className="utilities-wrapper cta">
                                { /* CTA */ } 
                                <CTA { ...ctaSettings } />
                            </div>
                        </div>
                    </div>
                    { /* Mobile Open */ }
                    <button id="af-navbar-toggle">
                        <span>Menu</span>
                    </button>
                </nav>
            </header>
        </>
    );
}
export default Header;